/* global _bncApp */
import React, { Component } from 'react';
import { TimelineMax, Power1 } from 'gsap';
import ScrollMagic from 'scrollmagic';
import { Dropdown } from '@bijie/react-bnb';
import styled from 'styled-components';
import Head from 'next/head';
import { Link } from '../../routes';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap'; // eslint-disable-line
import Container from '../Container';
import Icon from '../Icon';
import withI18n from '../../utils/withI18n';
import { getLabel } from '../../utils/i18n';
import { shouldUseAltUrl } from '../../utils/urlUtils';
import {
  Warp,
  StyletContainer,
  ItemBox,
  WrapImg,
  ItemContent,
  Title,
  Slogan,
  LinkBox,
  LinkButton,
  LinkButton2,
  MobileWrap,
  MobileLogo,
  MobileText,
  MobileTextItem,
  MobileTextSpan1,
  MobileTextSpan2,
  MobileTitle,
  MobileTitleItem,
  MobileImageAndText,
  MobileText1,
  MobileText2,
  MobileText3,
  MobileBtnWrap,
  MobileBtn,
  Andriod,
  GooglePlay,
  BinanceIcon,
} from '.';
import FlexBox from '../FlexBox';
import { isMobile, isTablet, isIPad, isIPhone } from '../../utils/ua';

const QRCode = require('qrcode.react');

type Props = {
  i18n: Object,
  speed: Number,
  contentNumIs3: boolean,
  locale: String,
};

const DropdownBox = styled(FlexBox)`
  width: 160px;
  height: 182px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ffffff;
  box-sizing: border-box;
  border-radius: 4px;
  svg {
    padding: 3px;
    background: #fff;
  }
`;

const CenterTitle = styled.span`
  font-family: ${({ theme }) => theme.fontIBMLight};
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #ffffff;
  margin-top: 6px;
`;

const PX2VW = 100 / 375;

// eslint-disable-next-line semi
const px2vw = (num: number): string => `${num * PX2VW}vw`;

export default
@withI18n
class DownloadPage extends Component<Props> {
  static defaultProps = {
    i18n: {},
    speed: 130,
    contentNumIs3: true,
  };

  componentDidMount() {
    window.document.body.style.background = 'rgb(18, 22, 28)';
    // const { ua } = this.props;
    // if (isMobile(ua)) {
    //   const $weiget = document.querySelector('#widget');
    //   $weiget.style?.display = 'none';
    // }
    const $android = document.querySelector('#android-img');
    const $pc = document.querySelector('#pc-img');
    const $mac = document.querySelector('#mac-img');
    const $androidText = document.querySelector('#downloadAddroid');
    const $pcText = document.querySelector('#downloadPc');
    const $apiText = document.querySelector('#downloadApi');
    const controller = new ScrollMagic.Controller({
      refreshInterval: 500,
      globalSceneOptions: {
        triggerHook: 'onLeave',
      },
    });
    const stat = new TimelineMax();
    stat
      .to(document.querySelector('#downloadApi'), 0, { visibility: 'hidden' }, 0)
      .to(document.querySelector('#downloadPc'), 0, { visibility: 'hidden' }, 0)
      .to(document.querySelector('#downloadApi'), 0, { visibility: 'hidden' }, 0);

    const andriod = new TimelineMax();
    andriod
      .from($androidText, 0, { opacity: 0 })
      .from($pcText, 0, { opacity: 0 })
      .from($apiText, 0, { opacity: 0 })
      // .fromTo($android, 5, { scale: 1, opacity: 1, ease: Power1.easeInOut }, { scale: 0.6, opacity: 0.5, ease: Power1.easeInOut })
      .fromTo(
        $android,
        0.1,
        { visibility: 'visible', ease: Power1.easeInOut },
        { visibility: 'hidden', ease: Power1.easeInOut }
      )
      .fromTo($androidText, 0, { visibility: 'hidden' }, { visibility: 'visible' })
      .fromTo(
        $androidText,
        1,
        { opacity: 1, y: 1 },
        {
          opacity: 0,
          y: -700,
          ease: Power1.easeInOut,
        }
      )
      .fromTo(
        $pc,
        0,
        { visibility: 'hidden', ease: Power1.easeInOut },
        { visibility: 'visible', ease: Power1.easeInOut }
      )
      .fromTo(
        $pc,
        4,
        { opacity: 0, ease: Power1.easeInOut },
        { opacity: 1, ease: Power1.easeInOut }
      )
      .fromTo($pcText, 0, { visibility: 'hidden' }, { visibility: 'visible' }, 1)
      .fromTo($pcText, 4, { opacity: 0, y: 700 }, { opacity: 1, y: 0, ease: Power1.easeInOut }, 1)
      // .fromTo($pc, 6, { scale: 1, ease: Power1.easeInOut }, { scale: 0.6, ease: Power1.easeInOut })
      .fromTo(
        $pc,
        0.1,
        { visibility: 'visible', ease: Power1.easeInOut },
        { visibility: 'hidden', ease: Power1.easeInOut }
      )
      .fromTo(
        $pcText,
        1,
        { opacity: 1, y: 1, scale: 1 },
        {
          opacity: 0,
          y: -700,
          scale: 0.98,
          ease: Power1.easeInOut,
        }
      )
      .fromTo(
        $mac,
        0,
        { visibility: 'hidden', ease: Power1.easeInOut },
        { visibility: 'visible', ease: Power1.easeInOut }
      )
      .fromTo(
        $mac,
        4,
        { opacity: 0, ease: Power1.easeInOut },
        { opacity: 1, ease: Power1.easeInOut }
      )
      .fromTo($apiText, 0, { visibility: 'hidden' }, { visibility: 'visible' }, 6)
      .fromTo($apiText, 4, { opacity: 0, y: 700 }, { opacity: 1, y: 0, ease: Power1.easeInOut }, 6);

    new ScrollMagic.Scene({
      duration: `${this.props.speed}%`,
      triggerElement: document.querySelector('#android'),
    })
      .setTween(andriod)
      .setPin('#android')
      .addTo(controller);
  }

  _toUrl = (url: string) => {
    window.location.href = url;
  };

  _renderWeb() {
    const { i18n } = this.props;
    const ua = navigator?.userAgent || '';
    return (
      <Warp display={isMobile(ua) || isTablet(ua) ? 'none' : 'block'}>
        <Container>
          <ItemBox id="android" align="center">
            <WrapImg>
              <img id="android-img" src={require('./image/app.png')} alt="" />
            </WrapImg>
            <WrapImg>
              <img id="pc-img" src={require('./image/mac.png')} alt="" />
            </WrapImg>
            <WrapImg>
              <img id="mac-img" src={require('./image/api.png')} alt="" />
            </WrapImg>
            <StyletContainer id="downloadAddroid">
              <ItemContent>
                <Title>{getLabel('exchange-index-exchangeEverywhere', i18n)}</Title>
                <Slogan>{getLabel('exchange-download-appDownloadDesc', i18n)}</Slogan>
                <LinkBox margin="10px 0 0">
                  <LinkButton
                    href="https://apps.apple.com/hk/app/binance/id1436799971?l=en"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <Icon type="Apple" size={34} color="#fff" />
                    <div>
                      <span>Download from</span>
                      <br />
                      <strong>App Store</strong>
                    </div>
                  </LinkButton>
                  <LinkButton
                    href="https://play.google.com/store/apps/details?id=com.binance.dev"
                    target="_blank"
                    rel="noreferrer noopener"
                    id="homepage-download-googlePlay"
                  >
                    <Icon type="google-play-colors" size={34} color="#fff" />
                    <div>
                      <span>{getLabel('exchange-index-getItOn', i18n)}</span>
                      <br />
                      <strong>Google Play</strong>
                    </div>
                  </LinkButton>
                  <LinkButton
                    href={
                      shouldUseAltUrl()
                        ? 'https://binance-1259603563.file.myqcloud.com/pack/Binance.apk'
                        : 'https://ftp.binance.com/pack/Binance.apk'
                    }
                    id="homepage-download-android"
                  >
                    <Icon type="andriod" size={34} color="#fff" />
                    <div>
                      <span>{getLabel('exchange-index-downloadFor', i18n)}</span>
                      <br />
                      <strong>Android</strong>
                    </div>
                  </LinkButton>
                  <Dropdown
                    overlay={
                      <DropdownBox>
                        <QRCode renderAs="svg" size={100} value={window.location.href} />
                        <CenterTitle>{getLabel('exchange-index-scanToDownload', i18n)}</CenterTitle>
                      </DropdownBox>
                    }
                    trigger={['hover']}
                  >
                    <LinkButton padding="17" href="#" id="homepage-download-android">
                      <Icon type="qr" size={30} />
                    </LinkButton>
                  </Dropdown>
                </LinkBox>
              </ItemContent>
            </StyletContainer>
            <StyletContainer className="hidden" id="downloadPc">
              <ItemContent>
                <Title>{getLabel('exchange-index-binanceDesktop', i18n)}</Title>
                <Slogan>{getLabel('exchange-index-deskTopDownloadDesc', i18n)}</Slogan>
                <LinkBox margin="10px 0 0">
                  <LinkButton
                    href={
                      shouldUseAltUrl()
                        ? 'https://binance-1259603563.file.myqcloud.com/desktop/Binance.dmg'
                        : 'https://ftp.binance.com/desktop/Binance.dmg'
                    }
                    target="_blank"
                    id="homepage-download-macos"
                    rel="noreferrer noopener"
                  >
                    <Icon type="Apple" size={34} color="#fff" />
                    <div>
                      <span>{getLabel('exchange-index-downloadFor', i18n)}</span>
                      <br />
                      <strong>MacOS</strong>
                    </div>
                  </LinkButton>
                  <LinkButton
                    href={
                      shouldUseAltUrl()
                        ? 'https://binance-1259603563.file.myqcloud.com/pc_pack/Binance.exe'
                        : 'https://ftp.binance.com/pc_pack/Binance.exe'
                    }
                    target="_blank"
                    id="homepage-download-windows"
                    rel="noreferrer noopener"
                  >
                    <Icon type="windows-fill" size={34} color="#fff" />
                    <div>
                      <span>{getLabel('exchange-index-downloadFor', i18n)}</span>
                      <br />
                      <strong>windows</strong>
                    </div>
                  </LinkButton>
                </LinkBox>
              </ItemContent>
            </StyletContainer>
            <StyletContainer className="hidden" id="downloadApi">
              <ItemContent>
                <Title>{getLabel('exchange-home-integrationTitle', i18n)}</Title>
                <Slogan>{getLabel('exchange-home-integrationDesc', i18n)}</Slogan>
                <LinkBox margin="10px 0 0">
                  <LinkButton2
                    href="https://github.com/binance-exchange/binance-official-api-docs"
                    target="_blank"
                    rel="noreferrer noopener"
                    id="homepage-download-api"
                  >
                    <div>{getLabel('exchange-home-buttonText', i18n)}</div>
                  </LinkButton2>
                </LinkBox>
              </ItemContent>
            </StyletContainer>
          </ItemBox>
        </Container>
      </Warp>
    );
  }

  _renderMobileBtn() {
    const { i18n, locale } = this.props;
    const ua = navigator?.userAgent || '';
    if (isIPad(ua) || isIPhone(ua)) {
      if (locale !== 'cn') {
        return (
          <MobileBtn isApple={true} onClick={() => _bncApp.downloadApp()}>
            {/* <Icon type="Apple" color="#fff" /> */}
            <BinanceIcon>
              <img alt="phone" title="phone" src={require('./newImage/binanceIcon.svg')} />
            </BinanceIcon>
            <div>
              <strong>App Store</strong>
              <br />
              {/* <span>{getLabel('exchange-Download-apple', i18n)}</span> */}
            </div>
          </MobileBtn>
        );
      }
      return (
        <Link route={`/${locale}/downloadTips`}>
          <MobileBtn isApple={true}>
            {/* <Icon type="Apple" color="#fff" /> */}
            <BinanceIcon>
              <img alt="phone" title="phone" src={require('./newImage/binanceIcon.svg')} />
            </BinanceIcon>
            <div>
              <strong>App Store下载</strong>
              <br />
              <span>{getLabel('exchange-Download-apple', i18n)}</span>
            </div>
          </MobileBtn>
        </Link>
      );
    }
    if (locale !== 'cn') {
      return (
        <>
          <MobileBtn onClick={() => _bncApp.downloadApp()}>
            {/* <Icon type="google-play-colors" color="#fff" /> */}
            <GooglePlay>
              <img alt="phone" title="phone" src={require('./newImage/googlePlay.svg')} />
            </GooglePlay>
            <div>
              <span>{getLabel('exchange-index-getItOn', i18n)}</span>
              <br />
              <strong>Google Play</strong>
            </div>
          </MobileBtn>
        </>
      );
    }
    return (
      <>
        <MobileBtn
          onClick={() => {
            this._toUrl(
              shouldUseAltUrl()
                ? 'https://binance-1259603563.file.myqcloud.com/pack/Binance.apk'
                : 'https://ftp.binance.com/pack/Binance.apk'
            );
          }}
        >
          {/* <Icon type="andriod" color="#fff" /> */}
          <Andriod>
            <img alt="phone" title="phone" src={require('./newImage/android.svg')} />
          </Andriod>
          <div>
            <span>{getLabel('exchange-index-downloadFor', i18n)}</span>
            <br />
            <strong>Android APK</strong>
          </div>
        </MobileBtn>
      </>
    );
  }

  _renderMobile() {
    const { i18n } = this.props;
    const ua = navigator?.userAgent || '';
    if (!(isMobile(ua) || isTablet(ua))) {
      return null;
    }
    return (
      <>
        <Head>
          <meta
            name="viewport"
            content="width=device-width,initial-scale=1.0,maximum-scale=1.0,minimum-scale=1.0,user-scalable=no"
          />
        </Head>
        <MobileWrap>
          <MobileLogo>
            <img alt="phone" title="phone" src={require('./newImage/banner.svg')} />
          </MobileLogo>
          <MobileTitle>
            <MobileTitleItem>{getLabel('exchang-app-download-part1titile', i18n)}</MobileTitleItem>
          </MobileTitle>
          <MobileText marginTop={true}>
            <MobileTextItem>
              <MobileTextSpan1>
                {getLabel('exchang-app-download-part1Advantages1-title', i18n)}
              </MobileTextSpan1>
              <MobileTextSpan2>
                {getLabel('exchang-app-download-part1Advantages1', i18n)}
              </MobileTextSpan2>
            </MobileTextItem>
          </MobileText>
          <MobileText marginTop={false}>
            <MobileTextItem>
              <MobileTextSpan1>
                {getLabel('exchang-app-download-part1Advantages2-title', i18n)}
              </MobileTextSpan1>
              <MobileTextSpan2>
                {getLabel('exchang-app-download-part1Advantages2', i18n)}
              </MobileTextSpan2>
            </MobileTextItem>
          </MobileText>
          <MobileText marginTop={false}>
            <MobileTextItem>
              <MobileTextSpan1>
                {getLabel('exchang-app-download-part1Advantages3-tiitle', i18n)}
              </MobileTextSpan1>
              <MobileTextSpan2>
                {getLabel('exchang-app-download-part1Advantages3', i18n)}
              </MobileTextSpan2>
            </MobileTextItem>
          </MobileText>
          <MobileImageAndText>
            <img
              style={{
                width: px2vw(123),
                height: px2vw(180),
              }}
              alt="phone"
              title="phone"
              src={require('./newImage/mobile2x.png')}
            />
            <MobileText1>
              <span>{getLabel('exchang-app-download-part2Advantages-tiitle', i18n)}</span>
              <span>{getLabel('exchang-app-download-part2Advantages', i18n)}</span>
            </MobileText1>
          </MobileImageAndText>
          <MobileImageAndText>
            <MobileText2>
              <span>{getLabel('exchang-app-download-part2Advantages2-tiitle', i18n)}</span>
              <span>{getLabel('exchang-app-download-part2Advantages2', i18n)}</span>
            </MobileText2>
            <img
              style={{
                width: px2vw(157),
                height: px2vw(200),
                // marginTop: px2vw(20),
              }}
              alt="phone"
              title="phone"
              src={require('./newImage/multiFait.png')}
            />
          </MobileImageAndText>
          <MobileImageAndText>
            <img
              style={{
                width: px2vw(308 / 2),
                height: px2vw(356 / 2),
              }}
              alt="phone"
              title="phone"
              src={require('./newImage/ecosystem2x.png')}
            />
            <MobileText3>
              <span>{getLabel('exchang-app-download-part2Advantages3-titile', i18n)}</span>
              <span>{getLabel('exchang-app-download-part2Advantages3', i18n)}</span>
            </MobileText3>
          </MobileImageAndText>
        </MobileWrap>
        <MobileBtnWrap>{this._renderMobileBtn(ua)}</MobileBtnWrap>
      </>
    );
  }

  render() {
    return (
      <>
        {this._renderWeb()}
        {this._renderMobile()}
      </>
    );
  }
}
